import React, { Fragment } from "react";
import { Route, Redirect } from "react-router-dom";
import { Header, Main, Footer, Success } from "./components/layout";
import JobDetails from "./components/layout/JobDetails/JobDetails";
import JobOpenings from "./components/layout/JobOpenings/JobOpenings";
import NotFound from './components/layout/NotFound/NotFound';

const App = () => {
  return (
    <Fragment>
      <Header />
      <Route exact path="/" component={JobOpenings} />
      <Route path="/apply" component={Main} />
      <Route path="/current-openings/details" component={JobDetails} />
      <Route path="/success" component={Success} />
      <Route path="*" component={NotFound} />
      <Footer />
    </Fragment>
  );
};

export default App;
